import { mapGetters } from 'vuex';

// Formattazione condivisa delle info di una freebet (importo, scadenza, restrizioni).
export default {
    computed: {
        ...mapGetters({
            getTreeV2: 'treeV2/getTree',
            getTreeLive: 'treeV2/getTreeLive',
        }),
        // sportId → nome, dai nodi sport già caricati per la navigazione.
        freeBetSportNames() {
            const names = {};
            [...(this.getTreeV2 || []), ...(this.getTreeLive || [])]
                .filter(node => node && node.type !== 'antepost_root' && node.name)
                .forEach(node => {
                    [node.sportId, node.icon_id].forEach(id => {
                        if (id != null && !names[String(id)]) names[String(id)] = node.name;
                    });
                });
            return names;
        },
    },
    methods: {
        formatFreeBetAmount(value) {
            return Number(value || 0).toFixed(2).replace('.', ',');
        },
        formatFreeBetDate(value) {
            const d = new Date(value);
            if (isNaN(d.getTime())) return value;
            const pad = n => String(n).padStart(2, '0');
            return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        freeBetSports(token) {
            const ids = (token.filters && token.filters.sportIds) || [];
            return ids.map(id => this.freeBetSportNames[String(id)] || this.$t('freeBets.sportFallback', { id }));
        },
        // Etichette tradotte per l'uso dentro la frase (es. "singola o multipla").
        freeBetFilterLabels(values) {
            return (values || []).map(v => {
                const key = `freeBets.labels.${String(v).toLowerCase()}`;
                return this.$te(key) || this.$te(key, this.$i18n.fallbackLocale) ? this.$t(key) : String(v).toLowerCase();
            });
        },
        freeBetJoinOr(list) {
            if (list.length <= 1) return list.join('');
            return `${list.slice(0, -1).join(', ')} ${this.$t('freeBets.rules.or')} ${list[list.length - 1]}`;
        },
        // Frase con le restrizioni del token, es. "Giocabile nello sport: Tennis,
        // in modalità live o prematch, di tipo singola o multipla, con almeno 2 eventi". Senza filtri: giocabile ovunque.
        freeBetRules(token) {
            const filters = token.filters || {};
            const sports = this.freeBetSports(token);
            const modes = this.freeBetFilterLabels(filters.betTypes);
            const types = this.freeBetFilterLabels(filters.betOrderTypes);

            const parts = [];
            if (sports.length) parts.push(this.$tc('freeBets.rules.sports', sports.length, { sports: sports.join(', ') }));
            if (modes.length) parts.push(this.$t('freeBets.rules.modes', { modes: this.freeBetJoinOr(modes) }));
            if (types.length) parts.push(this.$t('freeBets.rules.types', { types: this.freeBetJoinOr(types) }));
            const minEvents = Number(filters.minEvents) || 0;
            if (minEvents > 0) parts.push(this.$tc('freeBets.rules.minEvents', minEvents, { count: minEvents }));
            if (!parts.length) return this.$t('freeBets.rules.any');

            return `${this.$t('freeBets.rules.playable')} ${parts.join(', ')}`;
        },
    },
};
